import { Col, DatePicker, Form, Input, Row } from "antd";
import TextArea from "antd/lib/input/TextArea";
import React from "react";
import { useTranslation } from "react-i18next";
import { DateFormat } from "../../../../../constants/constants";
import { ControlFailureModel } from "../../../../../models/control-failure.model";
import { FormSectionProps } from "../../../../../models/form-section.model";
import { VALIDATION_UTIL } from "../../../../../utils/validation.utils";
import { InfoCircleIcon } from "../../../../atoms/icon";
import { AppChildrenSelect, AppSelect } from "../../../../atoms/select";


const OperationalSection = (props: FormSectionProps<ControlFailureModel>) => {


    const { t } = useTranslation();

    return (
        <div className="section-wrapper">

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("ControlFailure.lbShortNameEvent")}
                        name="short_name_for_event"
                        tooltip={{ title: t("ControlFailure.ttShortNameEvent"), icon: <InfoCircleIcon /> }}
                        rules={VALIDATION_UTIL.getRulesValidationField("short_name_for_event", props.requiredFields)}
                    >
                        <Input />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <AppSelect
                        placeholder={t("Global.plPleaseSelect")}
                        list={props.resources?.type_of_events}
                        label={t("ControlFailure.lbTypeOfEvent")}
                        name="type_of_event_id"
                        tooltip={{ title: t("ControlFailure.ttTypeOfEvent"), icon: <InfoCircleIcon /> }}
                        rules={VALIDATION_UTIL.getRulesValidationField("type_of_event_id", props.requiredFields)}
                    />
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={12}>
                    <Form.Item
                        label={t("ControlFailure.lbOccurrenceDate")}
                        name="occurrence_date_picker"
                        tooltip={{ title: t("ControlFailure.ttOccurrenceDate"), icon: <InfoCircleIcon /> }}
                        rules={VALIDATION_UTIL.getRulesValidationField("occurrence_date", props.requiredFields)}
                    >
                        <DatePicker format={DateFormat.view} placeholder={t("Global.plPleaseSelect")} />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        label={t("ControlFailure.lbRecognitionDate")}
                        name="recognition_date_picker"
                        tooltip={{ title: t("ControlFailure.ttRecognitionDate"), icon: <InfoCircleIcon /> }}
                        rules={VALIDATION_UTIL.getRulesValidationField("recognition_date", props.requiredFields)}
                    >
                        <DatePicker format={DateFormat.view} placeholder={t("Global.plPleaseSelect")} />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={12}>
                    <AppSelect
                        placeholder={t("Global.plPleaseSelect")}
                        list={props.resources?.categories?.filter(p => p.level === 1)}
                        label={t("ControlFailure.lbBaselIILevel1Category")}
                        name="category_id"
                        tooltip={{ title: t("ControlFailure.ttBaselIILevel1Category"), icon: <InfoCircleIcon /> }}
                        rules={VALIDATION_UTIL.getRulesValidationField("category_id", props.requiredFields)}
                    />
                </Col>
                <Col span={12}>

                    <AppChildrenSelect
                        parentName="category_id"
                        list={props.resources?.categories?.filter(p => p.level === 2)}
                        placeholder={t("Global.plPleaseSelect")}
                        listFilterName="parent_id"
                        label={t("ControlFailure.lbBaselIILevel2Category")}
                        name="category_level_2_id"
                        tooltip={{ title: t("ControlFailure.ttBaselIILevel2Category"), icon: <InfoCircleIcon /> }}
                        rules={VALIDATION_UTIL.getRulesValidationField("category_level_2_id", props.requiredFields)}
                    />
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <AppChildrenSelect
                        parentName="category_id"
                        list={props.resources?.categories?.filter(p => p.level === 3)}
                        placeholder={t("Global.plPleaseSelect")}
                        listFilterName="parent_id"
                        label={t("ControlFailure.lbLevel2Detail")}
                        name="category_level_3_id"
                        tooltip={{ title: t("ControlFailure.ttLevel2Detail"), icon: <InfoCircleIcon /> }}
                        rules={VALIDATION_UTIL.getRulesValidationField("category_level_3_id", props.requiredFields)}
                    />
                </Col>

            </Row>


            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("ControlFailure.lbDescriptionOfEvent")}
                        name="description"
                        rules={VALIDATION_UTIL.getRulesValidationField("description", props.requiredFields)}
                    >
                        <TextArea rows={5} maxLength={150} placeholder={t("ControlFailure.plDescriptionOfEvent")} />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <AppSelect
                        placeholder={t("Global.plPleaseSelect")}
                        list={props.resources?.failed_control_areas}
                        label={t("ControlFailure.lbFailedControlArea")}
                        name="failed_control_area_id"
                        tooltip={{ title: t("ControlFailure.ttFailedControlArea"), icon: <InfoCircleIcon /> }}
                        rules={VALIDATION_UTIL.getRulesValidationField("failed_control_area_id", props.requiredFields)}
                    />
                </Col>

            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("ControlFailure.lbDescriptionofFailedControl")}
                        name="failed_control_description"
                        rules={VALIDATION_UTIL.getRulesValidationField("failed_control_description", props.requiredFields)}
                    >
                        <TextArea rows={5} maxLength={150} placeholder={t("ControlFailure.plComments")} />
                    </Form.Item>
                </Col>
            </Row>

        </div>
    )
}

export default OperationalSection;